import partner from '@/shared/assets/logo/partner.svg';
import rudalink from '@/shared/assets/logo/rudalink.svg';
import station from '@/shared/assets/logo/station.svg';

/** Figma logo/Partnerstation (149 × 18) — "Partner" + "station" 두 조각 */
export function PartnerStationLogo() {
  return (
    <div
      role="img"
      aria-label="Partnerstation"
      className="relative h-[18px] w-[149px] shrink-0"
    >
      <div className="absolute" style={{ inset: '2.44% 46.31% 0.88% 0' }}>
        <img src={partner} alt="" className="block size-full" />
      </div>
      <div className="absolute" style={{ inset: '0 0.37% 1.75% 54.41%' }}>
        <img src={station} alt="" className="block size-full" />
      </div>
    </div>
  );
}

/** Figma logo/Rudalink (160 × 32) — 흰색 워드마크 */
export function RudalinkLogo() {
  return (
    <div
      role="img"
      aria-label="Rudalink"
      className="relative h-8 w-40 shrink-0 overflow-clip"
    >
      <div className="absolute" style={{ inset: '0 1.14% 0 1%' }}>
        <img src={rudalink} alt="" className="block size-full" />
      </div>
    </div>
  );
}
